import { createContext, useContext } from 'react'
import type { RoutingAdapter } from './routingAdapter'

export const RoutingAdapterContext = createContext<RoutingAdapter | null>(null)

/**
 * Read-handle to the adapter instance built by the closest
 * `<RoutingController>`. Returns `null` when the controller is not
 * mounted or the schema has not yet loaded. Sibling consumers (e.g.
 * RouteCard's `lineLookup` prop) read the lookup map through this hook
 * to avoid rebuilding the graph.
 *
 * Lives beside the context rather than inside the controller component so
 * neither forces a Fast Refresh remount of the other (TASK-570).
 */
export function useRoutingAdapter(): RoutingAdapter | null {
  return useContext(RoutingAdapterContext)
}
